import React, { useEffect, useState } from "react";
import { Button, Modal, Table } from "react-bootstrap";
import { toast } from "react-toastify";
import Sidebar from "../../common/Sidebar";
import { changeLimit, changePage, deleteStyleThunk, fetchStylesThunk, sortStylesThunk, updateStylesPositionThunk } from "../../apps/styleSlice";
import { useDispatch, useSelector } from "react-redux";
import AddStyles from "./AddStyles";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import EditStyle from "./EditStyle";
import ViewStyle from "./ViewStyle";



const Styles = () => {
  const dispatch = useDispatch();
  const { styles, total, pageCount, page, limit } = useSelector((store) => store?.style);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [shuffledData, setShuffledData] = useState([]);
  const [isReordered, setIsReordered] = useState(false);
  const [isCheckedItems, setIsCheckedItems] = useState([]);
  const [isUnCheckedItems, setIsUnCheckedItems] = useState([]);
  const [isSortButtonVisible, setIsSortButtonVisible] = useState();

  useEffect(() => {
    dispatch(changeLimit(10))
    dispatch(fetchStylesThunk({ params: { limit: 10, page: 1 } }));
  }, [showEditModal]);

  useEffect(() => {
    if (styles) {
        setIsCheckedItems(
          styles
            .filter(style => style?.isSorted)
            .map(style => style?._id)
        );
      setShuffledData([...styles]);
    }
  }, [styles]);

  const shouldCancelStart = (e) => {
    const tagName = e.target.tagName.toLowerCase();
    return ["button", "input", "textarea", "select", "i"].includes(tagName);
  };

  const limitHandler = async (e) => {
    await dispatch(changeLimit(e.target.value))
    await dispatch(fetchStylesThunk({ params: { limit: e.target.value, page: 1 } }));
    // await dispatch(changePage(1))
  }

  const handleView = (style) => {
    setSelectedStyle(style);
    setShowViewModal(true);
  };

  const handleEdit = (style) => {
    setSelectedStyle(style);
    setShowEditModal(true);
  };

  const SortableItem = SortableElement(({ item }) => (
    <tr key={item._id}>
      <td>{item?._id}</td>
      <td>{item?.title}</td>
      <td>{item?.prompt}</td>
      <td>{item?.height}</td>
      <td>{item?.width}</td>
      <td>{item?.position}</td>
      <td><input type="checkbox" checked={isCheckedItems.includes(item._id)} onChange={(e) => handleCheckedItems(e, item._id)} /></td>
      <td>
        <img src={item?.referenceImage} alt="Refrence-Image" width={120} height={150} />
      </td>
      <td>
        <img src={item?.thumb} alt="Thumbnail" width={120} height={150} />
      </td>
      <td>
        <div className="d-flex">
          <button className="btn action_btn" onClick={() => handleView(item)}>
            <i className="fa fa-eye"></i>
          </button>
          <button className="btn action_btn" onClick={() => handleEdit(item)}>
            <i className="fa fa-pencil"></i>
          </button>
          <button className="btn action_btn">
            <i className="fa fa-trash" onClick={() => deleteStyle(item._id)}></i>
          </button>
        </div>
      </td>
    </tr>
  ));

 const handleCheckedItems = (e, id) => {
    setIsSortButtonVisible(true)
    if (e.target.checked) {
      setIsUnCheckedItems((prevItems) => prevItems.filter(Id => Id !== id));
      return setIsCheckedItems((prevItems) => [...prevItems, id]);
    }
    else {
      // Remove item ID from checkedItems state if unchecked
      setIsUnCheckedItems((prevItems) => [...prevItems, id])
      setIsCheckedItems((prevItems) => prevItems.filter(Id => Id !== id));
    }
  }
  const sortStyles = async () => {
   if( isCheckedItems.length !== 0){

      await dispatch(sortStylesThunk({ id:isCheckedItems,isSorted:true }))
      // setIsCheckedItems([])
    }
    if( isUnCheckedItems.length !== 0){

      await dispatch(sortStylesThunk({ id:isUnCheckedItems,isSorted:false  }))
    }
    dispatch(fetchStylesThunk({ params: { limit, page } }));
    setIsSortButtonVisible(false)
  }

  const SortableList = SortableContainer(({ items }) => (
    <tbody>
      {items?.map((item, index) => (
        <SortableItem key={item._id} index={index} item={item} />
      ))}
    </tbody>
  ));

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const updatedData = arrayMoveImmutable(shuffledData, oldIndex, newIndex);

      // Assign new order based on the updated position
      const reorderedData = updatedData.map((item, index) => ({
        ...item,
        order: index + 1, // Assigning correct order starting from 1
      }));

      setShuffledData(reorderedData);
      setIsReordered(true);
    }
  };

  const handleSavePosition = async () => {
    const reorderedIds = shuffledData.map((item) => item._id);

    // Dispatch the update order action
    await dispatch(updateStylesPositionThunk({ order: reorderedIds }));

    // Fetch the updated styles to refresh UI
    dispatch(fetchStylesThunk({ params: { limit, page } }));
    setIsReordered(false);
    setIsCheckedItems([])
    toast.success("Order updated successfully!");
  };

  const handlePageClick = async (data) => {
    await dispatch(changePage(data.selected + 1));
    await dispatch(fetchStylesThunk({ params: { limit, page: data.selected + 1 } }));
  };

  const deleteStyle = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      await dispatch(deleteStyleThunk({ id }));
      dispatch(fetchStylesThunk({ params: { limit, page } }));
      Swal.fire("Deleted!", "The style has been deleted.", "success");
    }
  };

  return (
    <>
      <Sidebar />
      <div className="card">
        <div className="card-header bg-white card-header-wrapper">
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-0">Styles</h3>
            <Button className="btn add_btn" onClick={() => setShowAddModal(true)}>Add</Button>
          </div>
        </div>

        <div className="table-responsive">
          <Table>
            <thead>
              <tr>
                <th>Id</th>
                <th>Title</th>
                <th>Prompt</th>
                <th>Height</th>
                <th>Width</th>
                <th>Position</th>
                <th>Sort</th>
                <th>Reference Image</th>
                <th>Thumbnail</th>
                <th>Action</th>
              </tr>
            </thead>
            <SortableList items={shuffledData} onSortEnd={onSortEnd} axis="y" shouldCancelStart={shouldCancelStart} />
          </Table>
        </div>

        <div className="d-flex justify-content-end m-3">
          {isSortButtonVisible && (
            <Button onClick={sortStyles} className="me-2">Sort</Button>
          )
          }
          {isReordered && (
            <Button variant="success" onClick={handleSavePosition}>Save Position</Button>
          )}
        </div>

        {total > 0 && (
          <div className="d-flex justify-content-between align-items-center px-3 mb-2">
            <div>
              <select className="form-select" onChange={(e) => limitHandler(e)}>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
            <div>
              <ReactPaginate
                previousLabel={"<"}
                nextLabel={">"}
                breakLabel={"..."}
                pageCount={pageCount === 1 ? 1 : pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={(data) => handlePageClick(data)}
                containerClassName={"pagination justify-content-center"}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"pagination_prev"}
                previousLinkClassName={"page-link"}
                nextClassName={"pagination_next"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                forcePage={page - 1}
              />
            </div>
          </div>
        )}
      </div>



      {/* Modals */}
      <Modal show={showAddModal} size="xl">
        <Modal.Header closeButton onHide={() => setShowAddModal(false)}></Modal.Header>
        <Modal.Body><AddStyles /></Modal.Body>
      </Modal>

      <Modal show={showViewModal} size="lg" centered className="edit-modal">
        <Modal.Header closeButton onHide={() => setShowViewModal(false)} ><Modal.Title>Edit Style</Modal.Title></Modal.Header>
        <Modal.Body>{selectedStyle ? <ViewStyle styleItem={selectedStyle} onClose={() => setShowViewModal(false)} /> : <p>No Style selected.</p>}</Modal.Body>
      </Modal>

      <Modal show={showEditModal} size="lg" centered className="edit-modal">
        <Modal.Header closeButton onHide={() => setShowEditModal(false)} ><Modal.Title>Edit Style</Modal.Title></Modal.Header>
        <Modal.Body>{selectedStyle ? <EditStyle styleItem={selectedStyle} onClose={() => setShowEditModal(false)} /> : <p>No Style selected.</p>}</Modal.Body>
      </Modal>


    </>
  );
};

export default Styles;